import React from 'react';
import HouseIcon from '@mui/icons-material/House';
import Tooltip from '@mui/material/Tooltip';
import useDebugInformation from '../../../../../../hooks/useDebugInformation';
import AddIcCallSharpIcon from '@mui/icons-material/AddIcCallSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import CareClubMiniIcon from '../../../../../Icons/CareClubMini';

const name = "AccountTypeIcon"

type Props = {
    tooltip: string;
    parent: string;
    accountName: string;
}

const getIcon = (accountName: string) => {
    switch (accountName) {
        case "TRADETEK":
            return <AddIcCallSharpIcon />
        case "ONLINE":
            return <LanguageSharpIcon />
        case "CARECLUB":
        case "CARECLUBNC":
            return <CareClubMiniIcon />
        default:
            return <HouseIcon />
    }
}

const AccountTypeIcon: React.FC<Props> = ({ tooltip, parent, accountName }) => {

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { tooltip, parent, accountName })
    return (
        <Tooltip title={tooltip} >
            {getIcon(accountName)}
        </Tooltip>
    )
}

export default React.memo(AccountTypeIcon)